var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from "classnames";
import PropTypes from "prop-types";
var ModalFooter = function (props) {
    // @ts-ignore
    var children = props.children, className = props.className, __TYPE = props.__TYPE, remainingProps = __rest(props, ["children", "className", "__TYPE"]);
    return (React.createElement("div", __assign({ className: classNames("fr-modal__footer", className, "type-".concat(__TYPE)) }, remainingProps), children));
};
ModalFooter.defaultProps = { __TYPE: "ModalFooter" };
ModalFooter.propTypes = { __TYPE: PropTypes.string };
export default ModalFooter;
